export class SeccionPublicacion {
  public id: number;
  public nombre: string;

  constructor() { }
}
